// extracted by mini-css-extract-plugin
module.exports = {"richTable":"PageRichText_richTable__3ggk7","richtd":"PageRichText_richtd__yZgxx"};